// SaffronTownKashmir&Co — Product Page Floating Video Bubble
// Opens a click-to-watch modal with sound when the bubble is tapped.

document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.querySelector('[data-pfv]');
  if (!wrapper) return;

  var bubble = wrapper.querySelector('[data-pfv-bubble]');
  var modal = wrapper.querySelector('[data-pfv-modal]');
  var modalVideo = modal ? modal.querySelector('video') : null;
  var closeBtn = modal ? modal.querySelector('[data-pfv-close]') : null;

  function openModal() {
    if (!modal || !modalVideo || !bubble) return;
    var src = bubble.getAttribute('data-video-src');
    if (!src) return;
    modalVideo.src = src;
    modal.classList.add('is-open');
    modalVideo.muted = false;
    modalVideo.currentTime = 0;
    modalVideo.play().catch(function () {
      /* autoplay with sound can be blocked; user can press play manually */
    });
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!modal || !modalVideo) return;
    modal.classList.remove('is-open');
    modalVideo.pause();
    modalVideo.removeAttribute('src');
    modalVideo.load();
    document.body.style.overflow = '';
  }

  if (bubble) bubble.addEventListener('click', openModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
});
